module.exports = __webpack_public_path__ + "static/media/plus.db5787b9.svg";